module.exports = __webpack_public_path__ + "img/ThinPhone.1d12a14e.svg";